import React, { useEffect } from 'react'
import { BodyText, LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const TargetSavingGoals = () => {
      useEffect(() => {
            window.scrollTo(0, 0)
          }, [])
  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3>
                We believe the future belongs to the children so we have 
                decided leveling the playing field for them by enabling 
                the parents with ease


          </h3>
          <BodyText>
                hit target savings goals for the kid through the provision of 
                credit money this will also help the parents not to lose out on 
                savings reward as any parent that defaults in a 2month row will 
                be disqualified from the reward
          </BodyText>
          </LeftSection>
          <RightSection>
              <img src="img/Group 8614 (2).svg" alt="couple saving in a bottle" />
          </RightSection>
      </SavingsHeader>
      </SavingsWrapper>
  )
}